// extracted by mini-css-extract-plugin
module.exports = {"SpecialReward":"SpecialReward_SpecialReward__MbCNe"};